export const privateAlbumPath = 'private-album'
